import { forwardRef } from "react";
import { cn } from "lib/utils";
import styles from "./button.module.css";

const buttonVariants = {
  base: styles.base,
  config: {
    variants: {
      variant: {
        default: styles.default,
        outline: styles.outline,
        secondary: styles.secondary,
        link: styles.link,
      },
      size: {
        default: styles.defaultSize,
        sm: styles.sm,
        icon: styles.icon,
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
};

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof buttonVariants.config.variants.variant;
  size?: keyof typeof buttonVariants.config.variants.size;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={cn(
          styles.button,
          buttonVariants.base,
          variant && buttonVariants.config.variants.variant[variant],
          size && buttonVariants.config.variants.size[size],
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
